<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon v-if="$store.state.user!='' && $store.state.user!=null && (new Date($store.state.vencimiento))>(new Date())" @click="menu=!menu"></v-app-bar-nav-icon>
      <v-app-bar-title>
        <div class="d-flex align-center">
          <a href="https://caplp.org.ar/">
            <v-img
              alt="CAPLP"
              class="shrink mr-2"
              contain
              src="https://gestioncaplp.org.ar/imagenes/logocaplp2.png"
              transition="scale-transition"
              width="130"
            />
          </a>
        </div>
      </v-app-bar-title>
    </v-app-bar>
    <v-navigation-drawer v-if="$store.state.user!='' && $store.state.user!=null && (new Date($store.state.vencimiento))>(new Date())" app v-model="menu" temporary width="auto">
      <v-list class="pa-5">
        <v-list-tile avatar class="alineacentro">
          <v-row>
            <v-col cols="12" md="1" lg="1" class="alineacentro">
              <v-list-item-avatar>
                <img :src="fotouser" />
                <!--<img src="https://randomuser.me/api/portraits/men/85.jpg">-->
              </v-list-item-avatar>
            </v-col>
            <v-col class="alineacentro" cols="10" md="9" lg="9">
              <v-list-tile-content class="alineacentro">
                <v-list-item-title class="textoNegrita">{{$store.state.username}}</v-list-item-title>
                <v-list-item-title class="textoChicoNegrita">({{$store.state.user}})</v-list-item-title>
                <!-- <v-list-item-subtitle>{{$store.state.rolusuario}}</v-list-item-subtitle> -->
              </v-list-tile-content>
            </v-col>
            <v-col cols="2" md="2" lg="2" class="alineacentro">
              <v-btn
                icon
                color="grey"
                @click="menu=false"
              >
                <v-icon size="24px">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <div v-if="!$store.state.rolesusuario.includes(8) && !$store.state.rolesusuario.includes(9) && !$store.state.rolesusuario.includes(6) && !$store.state.rolesusuario.includes(7)">
          <div v-for="item in items" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesusuario.includes(8) && !$store.state.rolesusuario.includes(9)">
          <div v-for="item in itemsted" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesusuario.includes(9) && !$store.state.rolesusuario.includes(8)">
          <div v-for="item in itemscjg" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesusuario.includes(8) && $store.state.rolesusuario.includes(9)">
          <div v-for="item in itemstedcjg" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <div v-if="$store.state.rolesusuario.includes(6) || $store.state.rolesusuario.includes(7)">
          <div v-for="item in itemsautogestion" :key="item.title">
            <v-list-item
                v-if="!item.subLinks"
                link
                :to="item.link"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <div v-else>
                <v-list-item avatar class="v-list-item">
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-group>
                    <v-list-item sub-group v-for="(subLink, j) in item.subLinks" :key="j" :to="subLink.link" :active-class="color" avatar class="v-list-item">
                    <v-list-item-title v-text="subLink.title"/>
                    </v-list-item>
                </v-list-group>
                </v-list-item>
            </div>
          </div>
        </div>
        <v-list-item>
          <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
          <v-list-item-content>
            <v-btn
              color="primary"
              text
              @click="logout()"
            >Cerrar Sesión
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content color="primary" dark>
      <router-view />
    </v-content>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Footer from "./components/Footer.vue";
export default {
  name: 'App',
  components: {
    Footer: Footer
  },
  data: () => ({
    fotouser: '',
    items: [
          { title: 'Inicio', icon: 'mdi-home-city', link: '/home'},
          { title: 'Matriculados', icon: 'mdi-account', link: '',
            subLinks: [
              {
                link: '/tramitesmatriculas',
                title: 'Trámites',
                icon: 'mdi-home-city'
              },
              {
                link: '/cuotaanual',
                title: 'Cuota Anual hasta 2024',
                icon: 'mdi-home-city'
              },
              {
                link: '/cuotaanualv2',
                title: 'Cuota Anual 2025',
                icon: 'mdi-home-city'
              },
              {
                link: '/adminmatriculados',
                title: 'Fichero',
                icon: 'mdi-home-city'
              },
              {
                link: '/adminccmatriculado',
                title: 'Administrar Cuentas Corrientes',
                icon: 'mdi-home-city'
              },
              {
                link: '/consultamatriculados',
                title: 'Consulta de Matriculados',
                icon: 'mdi-home-city'
              },
              {
                link: '/listadosmatriculados',
                title: 'Listados de Matriculados',
                icon: 'mdi-home-city'
              },
              {
                link: '/deudamatriculados',
                title: 'Carga de Deuda de Matriculados',
                icon: 'mdi-home-city'
              },
              {
                link: '/conveniopago',
                title: 'Convenio de Pago',
                icon: 'mdi-home-city'
              },
              {
                link: '/tramitesmorosidad',
                title: 'Trámites de Morosidad',
                icon: 'mdi-home-city'
              },
              {
                link: '/certificadomatricula',
                title: 'Certificados de Matrícula',
                icon: 'mdi-home-city'
              },
              {
                link: '/infsaldosmatriculados',
                title: 'Informes de Saldos',
                icon: 'mdi-home-city',
              },
              {
                link: '/infantsaldoscc',
                title: 'Informes de Antiguedad de Saldos de Cuenta Corriente',
                icon: 'mdi-home-city',
              },
              {
                link: '/infmovmatriculados',
                title: 'Informes de Movimientos por Matriculado',
                icon: 'mdi-home-city',
              },
              {
                link: '/infvencdebmatriculado',
                title: 'Informe de Vencimientos de Débitos de Matriculados',
                icon: 'mdi-home-city',
              },
              {
                link: '/notificadeuda',
                title: 'Notificaciones de Deuda de Matriculados',
                icon: 'mdi-home-city',
              }
            ]
          },
          { title: 'Compras', icon: 'mdi-cart', link: '',
            subLinks: [
              {
                link: '/compras',
                title: 'Comprobantes de Compra',
                icon: 'mdi-home-city'
              },
              {
                link: '/imputacomp',
                title: 'Imputar Comprobantes de Compra',
                icon: 'mdi-home-city'
              },
              {
                link: '/infvencproveedores',
                title: 'Informe de Vencimiento de Proveedores',
                icon: 'mdi-home-city'
              },
              {
                link: '/infmovimproveedores',
                title: 'Informe de Movimientos de Proveedores',
                icon: 'mdi-home-city'
              },
              {
                link: '/infsaldosccproveedores',
                title: 'Informe de Saldos de Cuenta Corriente de Proveedores',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Tesorería', icon: 'mdi-cash-multiple', link: '',
            subLinks: [
              {
                link: '/recibos',
                title: 'Recibos',
                icon: 'mdi-home-city'
              },
              {
                link: '/ordenpago',
                title: 'Órdenes de Pago',
                icon: 'mdi-home-city'
              },
              {
                link: '/comvendolares',
                title: 'Compra/Venta de Dólares',
                icon: 'mdi-home-city'
              },
              {
                link: '/cobroventacheques',
                title: 'Cobro/Venta de Cheques en Cartera',
                icon: 'mdi-home-city'
              },
              {
                link: '/planillacaja',
                title: 'Planilla de Caja',
                icon: 'mdi-home-city'
              },
              {
                link: '/tasamix',
                title: 'Tasa Mix',
                icon: 'mdi-home-city'
              },
              {
                link: '/referenciavalores',
                title: 'Ref. Valores Matrícula',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Banco', icon: 'mdi-bank', link: '',
            subLinks: [
              {
                link: '/depositos',
                title: 'Depósitos Bancarios',
                icon: 'mdi-home-city'
              },
              {
                link: '/extracciones',
                title: 'Extracciones Bancarias',
                icon: 'mdi-home-city'
              },
              {
                link: '/transferencias',
                title: 'Transferencias Bancarias',
                icon: 'mdi-home-city'
              },
              {
                link: '/infmovcuentasbancarias/25',
                title: 'Informe Movimientos de Cuentas Bancarias',
                icon: 'mdi-home-city'
              },
              {
                link: '/infmovcuentasbancarias/26',
                title: 'Informe de Vencimientos de Cheuqes emitidos',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Contabilidad', icon: 'mdi-calculator', link: '',
            subLinks: [
              {
                link: '/ejercicioseconomicos',
                title: 'Ejercicios Económicos',
                icon: 'mdi-home-city'
              },
              {
                link: '/libromayor',
                title: 'Libro Mayor',
                icon: 'mdi-home-city'
              },
            //   {
            //     link: '/plancuentas',
            //     title: 'Plan de Cuentas',
            //     icon: 'mdi-home-city'
            //   }
            ]
          },
          { title: 'Administración', icon: 'mdi-email-multiple', link: '',
            subLinks:[
              {
                link: '/notaentrada',
                title: 'Notas de Entrada',
                icon: 'mdi-home-city'
              },
              {
                link: '/notasalida',
                title: 'Notas de Salida',
                icon: 'mdi-home-city'
              },
              {
                link: '/actasres/1',
                title: 'Actas del Consejo Directivo',
                icon: 'mdi-home-city'
              },
              {
                link: '/actasres/2',
                title: 'Resoluciones del Consejo Directivo',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Biblioteca', icon: 'mdi-bookshelf', link: '',
            subLinks:[
              {
                link: '/adminpublicaciones',
                title: 'Administración de Publicaciones',
                icon: 'mdi-home-city'
              },
              {
                link: '/bibliotecaprestamos',
                title: 'Prestamos',
                icon: 'mdi-home-city'
              },
              {
                link: '/bibliotecadevoluciones',
                title: 'Devoluciones',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Act. Académicas', icon: 'mdi-account-school', link: '',
            subLinks:[
              {
                link: '/adminactacademicas',
                title: 'Admin. Act. Académicas',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Referenciales del Sistema', icon: 'mdi-wrench-cog', link: '',
            subLinks: [
              {
                link: '/adminpersonas',
                title: 'Admin. Personas',
                icon: 'mdi-home-city'
              },
              {
                link: '/admincuentasbancarias',
                title: 'Admin. Cuentas Bancarias',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'Seguridad del Sistema', icon: 'mdi-security', link: '',
            subLinks: [
              {
                link: '/adminusuarios',
                title: 'Admin. Usuarios',
                icon: 'mdi-home-city'
              }
            ]
          },
          { title: 'CJG', icon: 'mdi-account-tie-voice', link: '',
            subLinks: [
              {
                link: '/adminconsultas',
                title: 'Administración de Consultas',
                icon: 'mdi-account-tie-voice'
              },
              {
                link: '/temasysubtemas',
                title: 'Alta y Modificación de Temas y Subtemas',
                icon: 'mdi-account-tie-voice'
              }
            ]
          }
    ],
    itemsted: [
      { title: 'Inicio', icon: 'mdi-scale-balance', link: '/home'},
      { title: 'Agenda', icon: 'mdi-calendar-month', link: '/agendated'},
      { title: 'Procesos', icon: 'mdi-scale-balance', link: '',
        subLinks: [
          {
            link: '/adminprocesos',
            title: 'Administración',
            icon: 'mdi-scale-balance'
          }
        ]
      }
    ],
    itemscjg: [
      { title: 'Inicio', icon: 'mdi-account-tie-voice', link: '/home'},
      { title: 'Consultas', icon: 'mdi-account', link: '',
        subLinks: [
          {
            link: '/adminconsultas',
            title: 'Administración',
            icon: 'mdi-account-tie-voice'
          }
        ]
      }
    ],
    itemstedcjg: [
      { title: 'Inicio', icon: 'mdi-scale-balance', link: '/home'},
      { title: 'TED', icon: 'mdi-scale-balance', link: '',
        subLinks: [
          {
            link: '/agendated',
            title: 'Agenda',
            icon: 'mdi-calendar-month'
          },
          {
            link: '/adminprocesos',
            title: 'Procesos',
            icon: 'mdi-scale-balance'
          }
        ]
      },
      { title: 'CJG', icon: 'mdi-account', link: '',
        subLinks: [
          {
            link: '/adminconsultas',
            title: 'Consultas',
            icon: 'mdi-account-tie-voice'
          }
        ]
      }
    ],
    itemsautogestion: [
      { title: 'Inicio', icon: 'mdi-scale-balance', link: '/micaplp'},
    ],
    menu: false,
  }),
  mounted() {
      this.fotouser= localStorage.getItem('foto');
  },
  methods:{
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.menu= false
        this.$router.push('/')
      })
    }
  },
  created: function () {
    this.$http.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response.status === 401) {
        if (this.$store.getters.authorized) {
          this.$store.dispatch('refreshtoken')
        } else {
          return Promise.reject(error)
        }
      } else {
        return Promise.reject(error)
      }
    })
  }
};
</script>
<style>
.v-list-item__title, .v-list-item__subtitle {
    flex: unset !important; /* 1 1 100%;*/
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color:red !important;
  font-weight:bold !important;
}
.textoNegritaVerde{
  color:rgb(83, 248, 125) !important;
  font-weight:bold !important;
}
.textoNegrita {
  font-weight:bold !important;
}
.textoChicoNegrita {
  font-weight:bold !important;
  font-size: small !important;
}
</style>
